export default (state = [], action) => {
  switch (action.type) {
    case 'FETCH_CHECKOUT_FORM':
      return action.payload
    default:
      return state
  }
}
